import axios from "axios";
import apiUrlOne from "../Config";

// Fetch all extra fees
export const getAllExtraFees = async () => {
    const response = await axios.get(`${apiUrlOne}/extrafee/getallextrafee`);
    return response.data;
};

// Update a specific extra fee by ID
export const updateExtraFee = async (id, updatedData) => {
    const response = await axios.put(
        `${apiUrlOne}/extrafee/updateextrafee/${id}`,
        updatedData,
        {
            headers: { "Content-Type": "application/json" },
        }
    );
    return response.data;
};